import React, { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useParams } from 'react-router-dom'
import { actionCreators as optimActionCreators } from '../../store/Optim.ts'
import { Tab, TabStrip } from '../common/TabStrip'
import { ProductBlock } from '../product-drawer/ProductBlock'
import { EditConstraints } from './EditConstraints'
import { SelectionBlockElement } from '../explore/SelectionBlockElement.js'
import { EditSliderConstraints } from './EditSliderConstraints'
import * as globals from '../../globals'
import './OptimizeEditorMulti.scss'
import { ProductBlockMini } from '../product-drawer/ProductBlockMini'

export const OptimizeEditorMulti = (props) => {
    const { studyId } = useParams()
    // const [selectedTabValue, setSelectedTabValue] = useState('product')
    const optState = useSelector(state => state.optimizer)
    const model = useSelector(state => state.model)
    const dispatch = useDispatch()
    const activeModel = props.activeConfig
    const truckImages = props.vehImages
    const suvTruck = useSelector(state => state.selection.suvTruck)
    
    // const { addOptimizationSelection, removeOptimizationSelection } = bindActionCreators(configActionCreators, dispatch)

    if (!optState || !model) return null

    // console.log('model', model);
    // console.log('activeconfig', activeModel);

    const products_to_opt = optState.goal.targetProducts || []
    const products = model?.[activeModel]?.config?.play
    const add_sel = { uid: '!add!' }
    const list = [...products_to_opt]//, add_sel]
    
    // const tab = selectedTabValue

    // const optFilter = {
	// 	item: {
	// 			data: {
	// 				type: suvTruck.uid === 1 ? 'ml_suvs' : 'ml_trucks', 
	// 				imageProperty: 'image',
	// 				imageFit: 'contain', 
	// 				largeImageForm: false,
	// 				largeImageHeight: 15,
	// 				largeImagePadding: 0,
    //                 imageStyle: { "border": "0px solid white", ":hover": { "cursor": "pointer", "transform": "scale(1.2)", "transition": "all ease 500ms" }, "height":"auto", "width":"30px", "marginLeft":"auto"},
	// 				hideLabel: false,
    //                 hideType: true,
    //                 style: { "height": 50, "border": "1px solid #ddd", "textTransform": "uppercase" }

	// 			}
	// 		}
    // }   

    // console.log('list[0]', list[0]);
    // console.log('model?.[activeModel].config', model?.[activeModel]?.config);

    const addClicked = () => {
        const selections = []
        window.topBar.openProducts(selections, (sel) => {
            dispatch(optimActionCreators.addOptimizationSelection(sel, (newSelections) => {                    
                window.topBar.hideMenu()
                }))
            },
            {
                allow: ['product'],
                multiSelect: false,
                activeModel
            }
        )
    }

    const deleteClicked = (sel) => {
        dispatch(optimActionCreators.removeOptimizationSelection(sel))
    }

    const selectClicked = (sel) => {
        dispatch(optimActionCreators.addOptimizationSelection(sel)) 
    }

     

    return (
        <div className="optimize-editor-multi" style={props.style}>
            {/* <div className="tab-section" style={{display: 'flex', justifyContent:'space-between'}}>
                <div>
                    <h3>Select target {props.productLabel} and attributes to allow the optimizer to change to produce the optimal result</h3>
                </div>               
            </div> */}

            <div className='product-grid-container'>
                <div className='product-grid1'>
                    <div style={{display:'flex', justifyContent:'space-between', width:'100%'}}>
                        <h3>Product/Attribute/Level Constraints</h3>
                        <ProductBlockMini
                            allow={['product']}
                            onClick={addClicked}
                            className='sel'
                            label={`+ add`} //target ${props.productLabel}`}
                            image={'optimizer_add_drk.png'}
                        />
                    </div>
                    {
                        list.map(prod =>
                            <div className='product-cell1' key={prod.uid}>
                                
                                <ProductBlock
                                    {...products.find(f => f.uid === prod.uid)}
                                    image={truckImages.find(f => f.uid === prod.uid)?.image}
                                    allow={['product']}
                                    allowDelete={true}
                                    onClick={() => selectClicked(prod)}
                                    onDelete={() => deleteClicked(prod)}
                                    selected = {products_to_opt.some(p => p.uid === prod.uid)}
                                    // className='sticky-top'
                                    styles={{backgroundColor:'#325373'}}
                                />
                                <EditConstraints prod={products.find(f => f.uid === prod.uid)} activeConfig={activeModel} />                                    
                            </div>
                        )
                    }
                </div>
            </div>
        </div>
    )
}



//                 <TabStrip onSelectedIndexChanged={(selectedTabIndex, selectedTabValue) => setSelectedTabValue(selectedTabValue)}>
//                     <Tab value='product'>Product</Tab>
//                     <Tab value='price'>Price</Tab>
//                     <Tab value='message'>Message</Tab>
//                     <Tab value='brand'>Brand</Tab>
//                 </TabStrip>

// {tab === 'price' && <EditConstraints prod={prod} activeConfig={activeModel} area="price" />}
//                                     {tab === 'message' && <EditSliderConstraints prod={prod} activeConfig={activeModel} area="message" />}
//                                     {tab === 'brand' && <EditSliderConstraints prod={prod} activeConfig={activeModel} area="brand" />}
